
import React from 'react';
import { 
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import NetworkTypeIcon from '@/components/dashboard/network/NetworkTypeIcon';
import { NetworkType } from '@/components/dashboard/network/NetworkTypes';

export interface Network {
  id: string;
  name: string;
  type: NetworkType;
  status: 'active' | 'inactive' | 'maintenance';
  metrics: {
    packetLoss: number;
    signalStrength: number;
    latency: number;
  };
}

interface NetworkSelectorProps {
  networks: Network[];
  selectedNetworkId: string;
  onNetworkChange: (networkId: string) => void;
}

const NetworkSelector: React.FC<NetworkSelectorProps> = ({
  networks,
  selectedNetworkId,
  onNetworkChange
}) => {
  return (
    <Select 
      value={selectedNetworkId}
      onValueChange={onNetworkChange}
    >
      <SelectTrigger className="w-full md:w-[250px]">
        <SelectValue placeholder="Select Network" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Available Networks</SelectLabel>
          {networks.map(network => (
            <SelectItem key={network.id} value={network.id} className="cursor-pointer">
              <div className="flex items-center">
                <NetworkTypeIcon type={network.type} className="mr-2" />
                <span>{network.name}</span>
                <span className="ml-2 text-xs text-muted-foreground">
                  ({network.type.toUpperCase()})
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default NetworkSelector;
